import { KeyValue } from '@/main/models/common';
import { AxiosResponse } from 'axios';
import { Result } from '../models/common/resultResponse';
import { IFileTypeApi } from './base';
import { api } from './base/api';

const baseRoute: string = 'FileType';

export class FileTypeApi extends IFileTypeApi {
  getDomain(
    idSystemApplication: number
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: { idSystemApplication } });
  }
}
